import script from "./textarea-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./textarea-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__